





































import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { RectangleLayer } from "@/model/document2/page/surface/design/layer/rectangleLayer";
import { CircleLayer } from "@/model/document2/page/surface/design/layer/circleLayer";
import { PolygonLayer } from "@/model/document2/page/surface/design/layer/polygonLayer";

import { ColorConstruct } from "@/utilityModels/colorConstruct";

import PatternKeepRatioController from "./patternKeepRatioController/patternKeepRatioController.vue";
import PolygonRadiusController from "./polygonRadiusController/polygonRadiusController.vue";
import RectangleRadiusController from "./rectangleRadiusController/rectangleRadiusController.vue";
import PatternStrokeWidthController from "./patternStrokeWidthController/patternStrokeWidthController.vue";
import PatternFillColorController from "./patternFillColorController/patternFillColorController.vue";
import PatternStrokeColorController from "./patternStrokeColorController/patternStrokeColorController.vue";
import PatternOpacityController from "./patternOpacityController/patternOpacityController.vue";

@Component({
    components: {
        PatternKeepRatioController,
        PolygonRadiusController,
        RectangleRadiusController,
        PatternStrokeWidthController,
        PatternFillColorController,
        PatternStrokeColorController,
        PatternOpacityController
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class PatternController extends Vue 
{
    @Prop() layer! : RectangleLayer | CircleLayer | PolygonLayer;

    private patternControllerType = "patternKeepRatio";

    private isActive(type)
    {
        return this.patternControllerType == type;
    }

    private changeType(type : string)
    {
        this.patternControllerType = type;
    }

    private onChangeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {   
        this.$emit("doCommand", "changeLayerProperty", {  
            layer : this.layer,
            propertyName : propertyName,
            value : value,
            isFinish : isFinish,
            isOnce : isOnce
        });
    }

    private onChangeGradationColor(index : number, value : ColorConstruct, isFinish : boolean)
    {
        this.$emit("doCommand", "changeGradationColorOfPattern", { 
            layer : this.layer, 
            index : index, 
            color : value, 
            isFinish : isFinish
        });
    }

    private onRequestColor(propertyName : string, currentValue : ColorConstruct)
    {
        var parameter = {};
        parameter["propertyName"] = propertyName;
        parameter["type"] = "color";
        var hex = currentValue.hex;
        if(hex.substr(0, 1) == "#") { hex = hex.substr(1, 6); }
        parameter["currentValue"] = hex;
        this.$emit("doCommand", "sendNativeEvent", {
            message : "request_layer_property",
            parameter : parameter
        });
    }
}
